<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div class="w-100" [innerHTML]='"copy.html.FIBWelcome.WelcomeCopy"|copy|async'></div>
    </div>
</div>